'use client'

import { Button } from '@achra/ui/button'
import { Link as LinkIcon } from 'lucide-react'
import type { BuilderLink } from '@/modules/__generated__/graphql/switchboard-generated'
import {
  LinksPopover,
  LinksPopoverItem,
  type MediaElement,
} from '@/modules/shared/components/links-popover'
import type { MouseEvent } from 'react'

function Links({ links }: { links: BuilderLink[] }) {
  const mediaElements: MediaElement[] = links.map((link) => ({
    type: link.label ?? 'link',
    href: link.url,
  }))

  const handlePopoverItemClick = (event: MouseEvent<HTMLElement>) => {
    // prevent the event to bubble up to the parent link to stop navigation to the builder page
    event.stopPropagation()
  }

  const handleTriggerClick = (event: MouseEvent<HTMLElement>) => {
    // prevent the event to bubble up to the parent link to stop navigation to the builder page
    event.preventDefault()
  }

  if (mediaElements.length === 0) {
    return null
  }

  return (
    <LinksPopover
      links={mediaElements}
      renderLinkItem={(link) => (
        <LinksPopoverItem
          key={`${link.href}-${'type' in link ? link.type : link.label}`}
          link={link}
          onClick={handlePopoverItemClick}
        />
      )}
    >
      <Button variant="secondary" onClick={handleTriggerClick} asChild>
        {/* Render the button as a div to comply with HTML standard (buttons can not be nested in links) */}
        <div role="button" aria-label="Open links popover">
          <LinkIcon /> <span className="inline sm:hidden md:inline">Links</span>
        </div>
      </Button>
    </LinksPopover>
  )
}

export { Links }
